/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import Navbar from "../components/navBar"
import Footer from "../components/footer"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.css"

const Layout = ({ children, pageInfo }) => (
    <div>
        <ToastContainer position="bottom-left" />
        <>
            <Container fluid className="px-0 main">
                <Navbar pageInfo={pageInfo} />
                <Row className={'fullheight'} noGutters={true}>
                    {children}
                </Row>
            </Container>

            {/*/!*footer section*!/*/}
            <Container fluid className="px-0">
                <div className={'row-fluid'}>
                    <Col className='fullHeight'>
                        <Row className={'footer'}>
                            <Footer />
                        </Row>
                    </Col>
                </div>
            </Container>
        </>
    </div>
)

export default Layout
